import React from "react";

interface Props {
  optionMenuGroup: server.dto.OptionMenuGroup
}

export const SingleSectionRightSideNavigation = (props: Props) => {
  return <div className="s1_related-feature-panel settings-navigation-wrapper">
    <div>
      <p className="info-text-semibold settings-navigation-subtitle">{props.optionMenuGroup.label}</p>
      <div className="settings-navigation-list">
        {props.optionMenuGroup.items.map(subItem => (
          <a key={subItem.url} href={subItem.url} className="settings-navigation-link">
            {subItem.label}
          </a>
        ))}
      </div>
    </div>
  </div>
} 